// Google Analytics 4 (GA4) helpers.
// The Measurement ID is read from NEXT_PUBLIC_GA_ID. When it is not set
// (or gtag hasn't loaded yet) every call is a safe no-op, so these helpers
// can be sprinkled through the app without guarding each call site.

export const GA_ID = process.env.NEXT_PUBLIC_GA_ID || ''

const canTrack = () =>
  typeof window !== 'undefined' &&
  typeof window.gtag === 'function' &&
  !!GA_ID

// Fire a GA4 event (view_item, add_to_cart, purchase, ...).
export const gaEvent = (event, params) => {
  if (!canTrack()) return
  if (params) {
    window.gtag('event', event, params)
  } else {
    window.gtag('event', event)
  }
}
